var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"sm":"8"}},[_vm._v(_vm._s(_vm.label))]),_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"sm":"4"}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }